import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index';
import { Base64 } from "js-base64";
import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Link } from "react-router-dom";
import 'react-vimeo/lib/Vimeo.css';
import GlobalHelper from "../common/GlobalHelper.jsx";
import ActionButton from "../common/button/actionbutton.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import Integrations from "../integration/Integrations.jsx";
import { INTEGRATION_KEY } from "../state/integration/Constants";
import PasswordRequirementToolTip from "../user/form/PasswordRequirementToolTip";
import PasswordStrengthVerificationInput from "../user/form/PasswordStrengthVerificationInput";
import IntegrationSignUpButtons from "./components/IntegrationSignUpButtons";
const queryString = require('query-string')
const Vimeo = require('react-vimeo');


const messages = defineMessages({
    docTitle: {
        id: 'signup.docHeader.title',
        defaultMessage: 'QuoteMachine - Powerful proposals.',
    },
    error_email_already_exists: {
        id: 'signup.error.email_already_exists',
        defaultMessage: 'The email associated with your {integrationName} account ({value}) already exists in our system. {linebreak} '
            + 'You should have received an email from QuoteMachine containing your temporary credentials which are different from the ones you use in {integrationName}.'
            + 'Use them to connect to QuoteMachine or please contact our support.',
    },
    error_no_access_rights: {
        id: 'signup.error.no_access_rights',
        defaultMessage: "The user {value} is not an administrator or owner. Please contact your adminstrator/owner in {integrationName} to get your credentials for QuoteMachine.",
    },
    error_invalid_email: {
        id: 'signup.error.invalid_email',
        defaultMessage: "Your user's email address ({value}) is invalid. In {integrationName}, verify that the field Email 1 of your employee is set correctly and try again.",
    },
    error_external_account_already_connected: {
        id: 'signup.error.external_account_already_connected',
        defaultMessage: "The {integrationName} account {value} is already connected to an existing QuoteMachine account. If you're an employee, contact your administrator/owner to get your credentials.",
    },
});

const SiteKey = '6Lc8pfUdAAAAAA21H34Qt_Y_uMtPbek2Eg4KleOX'
const GoogleReCaptchaUrl = 'https://www.google.com/recaptcha/api.js'
const BadgePosition = 'bottomleft'

class SignUp extends Component {

    constructor(props, context) {
        super(props, context);

        const lang = AppContext.getLocale().language

        const chunk = lang.split("-")
        let defaultCountry = "US"
        let defaultCurrency = "USD"
        if (chunk[1]) {
            defaultCountry = chunk[1]
        }
        if (defaultCountry === "CA") {
            defaultCurrency = "CAD"
        }
        const parsed = queryString.parse(location.search)
        this.state = {
            queryString: parsed,
            email: parsed.em || '',
            firstName: parsed.fn || '',
            lastName: parsed.ln || '',
            companyName: parsed.cn || '',
            city: parsed.ci || '',
            country: parsed.co || defaultCountry,
            state: parsed.se || '',
            street: parsed.st || '',
            postalCode: parsed.pc || '',
            error: parsed.error || '',
            promo: parsed.promo === '1',
            currency: parsed.cu || defaultCurrency,
            subscription: 'basic',
            status: 'trial',
            phoneNumber: parsed.pn || '',
            password: '',
            isPasswordAcceptable: false,
            modelAccountId: '',
            returnUrl: window.location.href,
            loading: false,
            industries: [],
            passwordRules: '',
            openIdError: '',
            referrer: parsed.ref || document.referrer || AppContext.getCookie('_referrer'),
            utmMedium: parsed.utm_medium || AppContext.getCookie('_utm_medium') || '',
            utmCampaign: parsed.utm_campaign || AppContext.getCookie('_utm_campaign') || '',
            utmSource: parsed.utm_source || AppContext.getCookie('_utm_source') || '',
            integrationKey: this.props.match.params.integrationKey || '',
            displayInternalForm: parsed.internal == "1",
        }
        this.handlePasswordScoreChange = this.handlePasswordScoreChange.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.postForm = this.postForm.bind(this)
    }

    componentDidMount() {
        const script = document.createElement('script')
        script.src = `${GoogleReCaptchaUrl}?badge=${BadgePosition}&render=${SiteKey}`
        document.body.appendChild(script)

        if (this.state.referrer) {
            AppContext.setCookie('_referrer', this.state.referrer)
        }
        if (this.state.utmMedium) {
            AppContext.setCookie('_utm_medium', this.state.utmMedium)
        }
        if (this.state.utmCampaign) {
            AppContext.setCookie('_utm_campaign', this.state.utmCampaign)
        }
        if (this.state.utmSource) {
            AppContext.setCookie('_utm_source', this.state.utmSource)
        }

        document.title = this.props.intl.formatMessage(messages.docTitle)
        this.setupIntercom()
        const uri = queryString.parse(window.location.search)
        if (uri.berr) {
            try {
                const error = JSON.parse(Base64.decode(uri.berr))
                let errorMessage = ''
                if (typeof error === "string") {
                    errorMessage = error
                } else if (error.error) {
                    errorMessage = error.error.message
                }
                const parsedMessage = errorMessage.split(':')
                const errorMessageId = parsedMessage[0]
                let value = ''
                if (parsedMessage.length > 1) {
                    value = parsedMessage[1]
                }

                let integrationName = ''
                if (value.includes(INTEGRATION_KEY.LIGHTSPEED_RETAIL)) {
                    integrationName = Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.LIGHTSPEED_RETAIL)
                }
                if (value.includes(INTEGRATION_KEY.SHOPIFY)) {
                    integrationName = Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.SHOPIFY)
                }
                if (value.includes(INTEGRATION_KEY.VEND)) {
                    integrationName = Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.VEND)
                }
                if (value.includes(INTEGRATION_KEY.SQUARE)) {
                    integrationName = Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.SQUARE)
                }


                this.setState({
                    openIdError: <p className={'text-danger mt-3 mb-0 text-justify'}>
                        <Icon value={'exclamation'} className={'mr-1'} />
                        {messages[errorMessageId] ? <FormattedMessage
                            {...messages[errorMessageId]}
                            values={{
                                value: value,
                                //backend should return the integration key in the error somehow
                                integrationName: integrationName,
                                linebreak: <span><br /><br /></span>,
                            }}
                        /> : errorMessage}
                    </p>
                })
            } catch (e) {
                console.log(e)
            }
        }
    }

    setupIntercom() {
        window.Intercom("boot", {
            app_id: GlobalHelper.getIntercomAppId(),
        })
        window.intercomSettings = {
            app_id: GlobalHelper.getIntercomAppId(),
            app_environment: AppContext.getOptions().environment,
            language_override: AppContext.getLocale().language,
        }
        window.Intercom("update")
    }

    postForm(e) {
        if (!this.state.email || (!GlobalHelper.checkPasswordRules(this.state.password) || !this.state.isPasswordAcceptable)) {
            e.preventDefault()
            return
        }
        if (this.state.email && this.state.companyName && this.state.password && this.state.password.length >= 6) {
            const { GTM } = this.props
            GTM.api.trigger({
                event: 'account_created',
                subscription: this.state.subscription
            })
            this.setState({
                loading: true,
            })
        }

    }

    handlePasswordScoreChange(isAcceptable) {
        this.setState({
            isPasswordAcceptable: isAcceptable
        })
        this.checkPasswordRules()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
        this.checkPasswordRules()
    }

    checkPasswordRules() {
        if (!GlobalHelper.checkPasswordRules(this.state.password)) {
            this.setState({
                passwordRules: <small className={"text-danger mt-1"}>
                    <FormattedMessage
                        id="user.password_rules.missing_requirements"
                        defaultMessage="Password is missing one or more requirements :"
                    />
                    <PasswordRequirementToolTip/>
                </small>
            })
        } else if (!this.state.isPasswordAcceptable) {
            this.setState({
                passwordRules: <small className={"text-danger mt-1"}>
                    <FormattedMessage
                        id="user.password_rules.easily_guessable"
                        defaultMessage="Unfortunately your password is easily guessable. Please try a different password."
                    />
                </small>
            })
        } else {
            this.setState({
                passwordRules: ''
            })
        }
    }

    render() {
        if (!this.state.displayInternalForm) {
            return <p>Not authorized</p>
        }

        const formStyle = {
            paddingLeft: "15px",
            paddingRight: "7px",
        }

        let error = ''
        if (this.state.error) {
            error = <div className="alert alert-danger" role="alert">
                {this.state.error}
            </div>
        }

        let btnText = <FormattedMessage
            id="signup.form.submit"
            defaultMessage="Get started"
        />
        if (this.state.loading) {
            btnText = <LoadingSpinner color="white" height={20} width={3} />
        }

        return (
            <div>
                <div className="d-flex justify-content-center my-4">
                    <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                        <div className="row">
                            <div className="col-12 mt-4">
                                <h1 className="text-center">
                                    <img src='/images/QuoteM_horizontal_flat.png' height='80px' />
                                </h1>
                            </div>
                        </div>

                        {this.state.promo && <div className={'row mb-4'}>
                            <div className={'col-12 px-0 mb-3 border-top pt-3'}>
                                <h3 className="text-center custom-lead">
                                    <FormattedMessage
                                        id="signup.form.promo_title"
                                        defaultMessage="Turn every conversation into online sales"
                                    />
                                </h3>
                                <p className="text-center">
                                    <FormattedMessage
                                        id="signup.form.promo_description"
                                        defaultMessage="Send online quotes, manage sales orders and get paid with online invoices. Look how your {quotes}, {orders} and {invoices} could look like."
                                        values={{
                                            quotes: <a href={GlobalHelper.getSampleQuoteUrl()} target={'_blank'}>
                                                <FormattedMessage
                                                    id="signup.form.promo_title_quotes"
                                                    defaultMessage="Quote"
                                                />
                                            </a>,
                                            orders: <a href={GlobalHelper.getSampleOrderUrl()} target={'_blank'}>
                                                <FormattedMessage
                                                    id="signup.form.promo_title_orders"
                                                    defaultMessage="Order Status"
                                                />
                                            </a>,
                                            invoices: <a href={GlobalHelper.getSampleInvoiceUrl()} target={'_blank'}>
                                                <FormattedMessage
                                                    id="signup.form.promo_title_invoices"
                                                    defaultMessage="Invoice"
                                                />
                                            </a>,
                                        }}
                                    />
                                </p>
                            </div>
                            <div className={'col-12 p-0 ui-module'}>
                                <Vimeo videoId={'470254940'} playerOptions={{
                                    byline: false,
                                    controls: false,
                                    portrait: false,
                                    title: false,
                                }} />
                            </div>
                        </div>}

                        <div className="row pb-3 pt-4 mt-2 bg-light border rounded-top">
                            <div className="col-12 text-center">
                                <h3 className="col-12 mb-1">
                                    {this.state.integrationKey ? <FormattedMessage
                                        id="signup.form.lite_title"
                                        defaultMessage="Start your 14-days free trial"
                                    /> : <FormattedMessage
                                        id="signup.form.free_title"
                                        defaultMessage="Start your free account"
                                    />}
                                </h3>
                                <h6>
                                    <FormattedMessage
                                        id="signup.form.no_credit_card_necessary"
                                        defaultMessage="No credit card required"
                                    />
                                </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="row justify-content-center flex-fill">
                                    <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12 col-xl-12 bg-white ui-module py-4 px-3 px-sm-5"
                                        style={{
                                            "borderLeftRightRadius": 0,
                                            "borderTopRightRadius": 0,
                                        }}>
                                        <div className="w-100">
                                            <IntegrationSignUpButtons
                                                referrer={this.state.referrer}
                                                utmMedium={this.state.utmMedium}
                                                utmCampaign={this.state.utmCampaign}
                                                utmSource={this.state.utmSource}
                                            />
                                            {this.state.openIdError}
                                        </div>
                                        {!this.state.integrationKey &&
                                            <div>
                                                <div className="row d-flex align-items-center pb-3 pt-3">
                                                    <div className="flex-grow-1"><hr /></div>
                                                    <span className="ml-2 mr-2 mt-1">
                                                        <strong>
                                                            <FormattedMessage
                                                                id="signup.or_label"
                                                                defaultMessage="OR"
                                                            />
                                                        </strong>
                                                    </span>
                                                    <div className="flex-grow-1"><hr /></div>
                                                </div>

                                                <div className="row justify-content-center">
                                                    <div className="col-md-12 col-12">
                                                        {error}
                                                        <form id="register-form"
                                                            style={formStyle}
                                                            onSubmit={this.postForm}
                                                            action={AppContext.getOptions().apiUrl + '/signup'}
                                                            method="POST">
                                                            <input type="hidden" name="currency" value={this.state.currency} />
                                                            <input type="hidden" name="language" value={AppContext.getLocale().getLanguage()} />
                                                            <input type="hidden" name="city" value={this.state.city} />
                                                            <input type="hidden" name="countryCode" value={this.state.country} />
                                                            <input type="hidden" name="state" value={this.state.state} />
                                                            <input type="hidden" name="street" value={this.state.street} />
                                                            <input type="hidden" name="postalCode" value={this.state.postalCode} />
                                                            <input type="hidden" name="returnUrl" value={this.state.returnUrl} />
                                                            <input type="hidden" name="status" value={this.state.status} />
                                                            <input type="hidden" name="subscription" value={this.state.subscription} />
                                                            <input type="hidden" name="referrer" value={this.state.referrer} />
                                                            <input type="hidden" name="utmMedium" value={this.state.utmMedium} />
                                                            <input type="hidden" name="utmCampaign" value={this.state.utmCampaign} />
                                                            <input type="hidden" name="utmSource" value={this.state.utmSource} />
                                                            <input type="hidden" name="approvedTerms" value="true" />
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="row form-group">
                                                                        <label className={"mb-0"} htmlFor="companyName">
                                                                            <small>
                                                                                <FormattedMessage
                                                                                    id="signup.company_name_label"
                                                                                    defaultMessage="Company name"
                                                                                />
                                                                            </small>
                                                                        </label>
                                                                        <input type="text"
                                                                            className="form-control mb-2 mb-sm-0"
                                                                            id="companyName"
                                                                            onChange={this.handleFormChange}
                                                                            name="companyName"
                                                                            autoComplete="organization"
                                                                            value={this.state.companyName}
                                                                            required
                                                                        />
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-6 col-sm-12">
                                                                            <div className="row form-group">
                                                                                <label className={"mb-0"} htmlFor="firstName">
                                                                                    <small>
                                                                                        <FormattedMessage
                                                                                            id="signup.first_name_label"
                                                                                            defaultMessage="First name"
                                                                                        />
                                                                                    </small>
                                                                                </label>
                                                                                <input type="text"
                                                                                    className="form-control mb-2 mb-sm-0"
                                                                                    id="firstName"
                                                                                    onChange={this.handleFormChange}
                                                                                    name="firstName"
                                                                                    autoComplete="given-name"
                                                                                    value={this.state.firstName}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 col-sm-12">
                                                                            <div className="row form-group pl-md-2 pl-sm-0">
                                                                                <label className={"mb-0"} htmlFor="lastName">
                                                                                    <small>
                                                                                        <FormattedMessage
                                                                                            id="signup.last_name_label"
                                                                                            defaultMessage="Last name"
                                                                                        />
                                                                                    </small>
                                                                                </label>
                                                                                <input type="text"
                                                                                    className="form-control mb-2 mb-sm-0"
                                                                                    id="lastName"
                                                                                    onChange={this.handleFormChange}
                                                                                    name="lastName"
                                                                                    autoComplete="family-name"
                                                                                    value={this.state.lastName}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row form-group">
                                                                        <label className={"mb-0"} htmlFor="email">
                                                                            <small>
                                                                                <FormattedMessage
                                                                                    id="signup.email_label"
                                                                                    defaultMessage="Email"
                                                                                />
                                                                            </small>
                                                                        </label>
                                                                        <input type="email"
                                                                            className="form-control mb-2 mb-sm-0"
                                                                            id="email"
                                                                            onChange={this.handleFormChange}
                                                                            name="email"
                                                                            autoComplete="email"
                                                                            value={this.state.email}
                                                                            required
                                                                        />
                                                                    </div>
                                                                    <div className="row form-group">
                                                                        <label className={"mb-0"} htmlFor="phoneNumber">
                                                                            <small>
                                                                                <FormattedMessage
                                                                                    id="signup.phone_number_label"
                                                                                    defaultMessage="Phone number"
                                                                                />
                                                                            </small>
                                                                        </label>
                                                                        <input type="tel"
                                                                            className="form-control mb-2 mb-sm-0"
                                                                            id="phoneNumber"
                                                                            onChange={this.handleFormChange}
                                                                            name="phoneNumber"
                                                                            value={this.state.phoneNumber}
                                                                            autoComplete="tel"
                                                                            required
                                                                        />
                                                                    </div>
                                                                    <div className="row form-group">
                                                                        <label className={"mb-0"} htmlFor="password">
                                                                            <small>
                                                                                <FormattedMessage
                                                                                    id="signup.password_label"
                                                                                    defaultMessage="Password"
                                                                                />
                                                                            </small>
                                                                        </label>
                                                                        <div className="col-12 px-0">
                                                                            <PasswordStrengthVerificationInput
                                                                                handleFormChange={this.handleFormChange}
                                                                                handlePasswordScoreChange={this.handlePasswordScoreChange}
                                                                                inputName="password"
                                                                                value={this.state.password}
                                                                                required={true}

                                                                            />
                                                                            {this.state.passwordRules}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div
                                                                className={'g-recaptcha'}
                                                                data-sitekey={SiteKey}
                                                                data-size='invisible'
                                                            />

                                                            <div className="row justify-content-center">
                                                                <div className="col-12 text-center px-0 pb-1 pt-3">
                                                                    <ActionButton type="submit" className="btn btn-primary w-100" disabled={this.state.loading} onClick={e => {
                                                                        let form = document.getElementById("register-form")
                                                                        window.grecaptcha.execute().then(token => {
                                                                            if (!token) {
                                                                                this.setState({message: 'recaptcha_token_generation_error'})
                                                                                return
                                                                            }

                                                                            form.submit()
                                                                        })
                                                                    }}>
                                                                        {btnText}
                                                                    </ActionButton>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="row justify-content-center">
                                            <div className="col-12 text-center px-0 pt-3">
                                                <p className={"mb-0"}>
                                                    <small>
                                                        <FormattedMessage
                                                            id="signup.approve_terms_and_privacy_message"
                                                            defaultMessage="By clicking the button you agree to our {terms} and our {privacy}"
                                                            values={{
                                                                terms: (
                                                                    <Link to='https://quotemachine.com/terms-of-use' target='_blank'>
                                                                        <FormattedMessage
                                                                            id="signup.terms_of_use.linked_text"
                                                                            defaultMessage="terms of use"
                                                                        />
                                                                    </Link>
                                                                ),
                                                                privacy: (
                                                                    <Link to='https://quotemachine.com/privacy-policy' target='_blank'>
                                                                        <FormattedMessage
                                                                            id="signup.privacy_policy.linked_text"
                                                                            defaultMessage="privacy policy"
                                                                        />
                                                                    </Link>
                                                                ),
                                                            }} />
                                                    </small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <p className="text-align-center">
                                            <Link to={'/p/signin'}>
                                                <FormattedMessage
                                                    id="sign_in.already_have_account"
                                                    defaultMessage="Already have an account ?"
                                                />
                                            </Link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default injectIntl(SignUp);


// WEBPACK FOOTER //
// ./src/auth/signup.component.jsx